import { AIR_KEY, HOTEL_KEY } from '../constants/categoryConstants';
import { ONEWAY, ROUNDTRIP, TRIP_TYPES } from '../constants/tripConstants';
import DIRECTION_TYPES from '../constants/directionConstants';

const formatDate = (date, locale) => new Date(date).toLocaleDateString(locale, {
  weekday: 'short',
  month: 'short',
  day: 'numeric',
  year: 'numeric',
  timeZone: 'UTC',
});

const convertToPascalCase = (str) => {
  const regex = /(\w)(\w*)/g;
  return str.replace(regex, (char0, char1, char2) => char1.toUpperCase() + char2.toLowerCase());
};

const formatDatesForPicker = (date, locale) => date && new Date(date).toLocaleDateString(locale, {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  timeZone: 'UTC',
});

const formatAirportCode = (code) => (code ? ` (${code})` : '');

const getRecentSearchName = ({
  originCity,
  destinationCity,
  searchStartTerm,
  searchDestinationTerm,
  originAirportCode,
  destinationAirportCode,
  startDate,
  endDate,
  locale,
  connector,
  destinationSearchTerm,
}) => {
  let name = '';
  if (originCity && destinationCity) {
    name = `${convertToPascalCase(originCity)}${formatAirportCode(originAirportCode)} ${connector} ${convertToPascalCase(destinationCity)}${formatAirportCode(destinationAirportCode)}`;
  } else if (originCity) {
    name = `${convertToPascalCase(originCity)}${formatAirportCode(originAirportCode)}`;
  } else if (destinationCity) {
    name = `${convertToPascalCase(destinationCity)}${formatAirportCode(destinationAirportCode)}`;
  }
  if (searchStartTerm) {
    name = searchStartTerm;
  } else if (searchDestinationTerm) {
    name = searchDestinationTerm;
  } else if (destinationSearchTerm) {
    name = destinationSearchTerm;
  }
  if (startDate && endDate) {
    name = `${name} <br> ${formatDate(startDate, locale)} - ${formatDate(endDate, locale)}`;
  } else if (startDate) {
    name = `${name} <br> ${formatDate(startDate, locale)}`;
  } else if (endDate) {
    name = `${name} <br> ${formatDate(endDate, locale)}`;
  }
  return name;
};

const isValidForTripType = (search, tripType) => {
  switch (tripType) {
    case TRIP_TYPES.ROUND_TRIP:
      return search.journeyType === ROUNDTRIP;
    case TRIP_TYPES.ONE_WAY:
      return search.journeyType === ONEWAY;
    default:
      return false;
  }
};

const isValidDirectionForFlight = (direction) => direction === DIRECTION_TYPES.DEPARTURE;

const filterByLobAndTripType = ({
  recentSearches, lineOfBusiness, direction, tripType,
}) => recentSearches.filter((search) => {
  if (lineOfBusiness === HOTEL_KEY) {
    return search.category === HOTEL_KEY;
  }
  return search.category === AIR_KEY
    && isValidForTripType(search, tripType)
    && isValidDirectionForFlight(direction);
});

export {
  formatDate,
  convertToPascalCase,
  getRecentSearchName,
  formatDatesForPicker,
  formatAirportCode,
  filterByLobAndTripType,
  isValidDirectionForFlight,
};
